
/* System defined core library */
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

/* User defined library/components */

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { Slot } from '../../../../shared/models/scheduling/slot.model';

@Component({
  selector: 'app-slot-card-detail',
  templateUrl: './slot-card-detail.component.html',
  styleUrls: ['../testcenter-selecter/testcenter-selecter.component.scss']
})

export class SlotCardDetailComponent {

  /* User defined private/public variables  */
  public errorMessage: string

  /* Input-OutPut parameters decalartions */
  @Input() public targetFlow: string;
  @Input() public availableSlots: Slot[];
  @Input() public highLightSiteSlot: AppointmentDetail;
  @Output() public selectedSlot: EventEmitter<Slot> = new EventEmitter();

  /* View child for focus */
  @ViewChild('testcenterTimes') testcenterTimes: ElementRef;

  /* Constructor declaration with required injected services */
  constructor() {

  }

  // ElementRef undefined until after ngOnInit
  ngAfterViewInit() {
    // set default focus on parant div for screen reader
    if (!!this.testcenterTimes) {
      this.testcenterTimes.nativeElement.focus();
    }
  }

  /* Add active class of selected slot and emit selected slot to siteslot screen */
  setSelectedSlot(event: any, selectedSlot: Slot) {
    this.selectedSlot.emit(selectedSlot);
  }

  activeClass(slot: Slot, classString: string): string {
    return this.isSlotSelected(slot) ? classString : '';
  }

  isSlotSelected(slot: Slot): boolean {
    return (
      !!slot &&
      !!this.highLightSiteSlot.hold.slot &&
      this.highLightSiteSlot.hold.slot.startDateTime == slot.startDateTime
    );
  }
}